import React from 'react';
import withAppBar from '../components/AppBar';
import { Route } from 'react-router-dom';
import MainMenu from './MainMenu';
import { KeraileJaLaheta, VastaanotaKorjaamolla, VaihdaJaLahetaVarastolle, VastaanotaVarastolla, Hyllyta } from './tireChanging/TireChangingScreen';
import UserMenu from './UserMenu';
import ChooseLocation from './ChooseLocation';

const MainContent = () => < >      
    <Route exact path="/" component={MainMenu} />
    <Route exact path="/keraileJaLaheta" component={KeraileJaLaheta} />
    <Route exact path="/vastaanotaKorjaamolla" component={VastaanotaKorjaamolla} />
    <Route exact path="/vaihdaJaLahetaVarastolle" component={VaihdaJaLahetaVarastolle} />
    <Route exact path="/vastaanotaVarastolla" component={VastaanotaVarastolla} />
    <Route exact path="/hyllyta" component={Hyllyta} />
    <Route exact path="/user" component={UserMenu} />
    <Route exact path="/valitseToimipiste" component={ChooseLocation} />
  </>

const MainScreen = withAppBar(MainContent);
export default MainScreen;